module.exports = __webpack_public_path__ + "img/form_logo.ae560bbd.png";